import React from 'react';

export interface HeaderPrimaryAddButtonProps {
  label: string;
  onClick: () => void;
  mobileAriaLabel?: string;
}

/** Primary create action in DarkLayout header (desktop + mobile FAB). */
export const HeaderPrimaryAddButton: React.FC<HeaderPrimaryAddButtonProps> = ({
  label,
  onClick,
  mobileAriaLabel,
}) => (
  <>
    <button
      type="button"
      onClick={onClick}
      className="hidden md:flex items-center gap-2 bg-primary hover:bg-primary/90 text-white px-4 py-2 rounded-lg text-sm font-bold shadow-lg shadow-primary/20 transition-all"
    >
      <span className="material-symbols-outlined text-lg">add</span>
      {label}
    </button>
    <button
      type="button"
      onClick={onClick}
      className="md:hidden flex items-center justify-center rounded-full size-10 bg-primary text-white shadow-lg shadow-primary/20"
      aria-label={mobileAriaLabel ?? label}
    >
      <span className="material-symbols-outlined">add</span>
    </button>
  </>
);
